var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('Input',{attrs:{"labelText":"Location Name"}})],1),_c('div',[_c('ButtonClassic',{attrs:{"labelText":"Add"}}),_c('ButtonClassic',{attrs:{"labelText":"Cancel"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }